import { Component } from './Component';

export class P extends Component {
	constructor(attribute, children) {
		super('p', attribute, children);
	}
}
